export class DashboardItem {
  public visible: boolean;
  public data: any;
}
